<template>
  <div class="Questions">
    <Header msg='问题答疑'/>
    <div class="Questions-content">
        <div class="problem">
          <input type="radio" id="item1" name="item">
          <label for="item1">1.学生如何自己修改性别</label>
          <div class="context">
            <p>前往【陈文卫成高】公众号 -【个人中心】-【我的信息】进行修改</p>
           </div>
        </div>

        <div class="problem">
          <input type="radio" id="item2" name="item">
          <label for="item2">2.学生线上报名后在哪里看考前辅导课</label>
          <div class="context">
            <p>前往【陈文卫成高】公众号 - 【个人中心】-【我的课程】查看</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item3" name="item">
          <label for="item3">3.学员如何查看自己是否有未支付订单</label>
          <div class="context">
            <p>前往【陈文卫成高】公众号 -【个人中心】-【我的订单】可查看</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item4" name="item">
          <label for="item4">4.如何查看学员是否是扫自己的二维码提交的订单</label>
          <div class="context">
            <p>第一，可到【人人招生】-【我的学生】，在 未支付 或 已报名 处可看是否有学生的订单，如有，则是；第二，可让学生到【个人中心】-【我的订单】查看订单中服务老师的名字是不是自己的，如是，则对。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item5" name="item">
          <label for="item5">5.学员报名时未选介绍人，报名后多久可补加介绍人</label>
          <div class="context">
            <p>学员缴费报名后的48小时之内可提交添加介绍人修改申请，超过48小时则无法提交。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item6" name="item">
          <label for="item6">6.在哪里可提交添加介绍人的修改申请</label>
          <div class="context">
            <p>前往【陈文卫成高】公众号 -【人人招生】-【我的学生】-【已报名】-【修改推荐人】进行提交修改申请</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item7" name="item">
          <label for="item7">7.提交介绍人修改申请上传图片规范</label>
          <div class="context">
            <p>上传的图片中需包括A介绍B，B是A介绍过来的聊天截图，聊天截图中要体现双方的名字和介绍关系，不允许报名后补充的体现推荐关系的聊天截图</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item8" name="item">
          <label for="item8">8.已线下给介绍费学员的还需要在成高系统添加介绍人吗</label>
          <div class="context">
            <p>已给介绍费的不需要在成高系统上提交修改申请，直接联系学邦系统管理员在学邦系统上添加介绍人即可</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item9" name="item">
          <label for="item9">9.什么情况下用户不能添加成为自己的助理合伙人</label>
          <div class="context">
            <p>以下三种情况不支持修改助理合伙人：1、助理合伙人的粉丝；2、已是报名学员且未是助理合伙人；3、已是助理合伙人且介绍过学员报名。如要给介绍费请走线下流程</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item10" name="item">
          <label for="item10">10.提交添加介绍人修改申请时，搜索不到介绍人名字</label>
          <div class="context">
            <p>以下几种情况会搜索不到介绍的名字：第一、介绍人已是其他人的助理合伙人；第二、介绍人已是其他老师的已报名学员；第三、介绍人还不是成高系统的用户，可先推送一张海报发介绍人，让识别二维码成为系统的用户或直接让介绍人成为自己的助理合伙人即可。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item11" name="item">
          <label for="item11">11.一个微信可以提交多条报名订单吗</label>
          <div class="context">
            <p>目前系统只可支持一个微信号提交一条订单，如需要报名可走线下报名流程或学员用另外一个微信报名即可。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item12" name="item">
          <label for="item12">12.用户提交订单时提示【用户状态异常】或【该预报名单已报名】信息</label>
          <div class="context">
            <p>可让学员到我的订单处查看是否有一个未支付订单，如有，可确认服务老师是否是自己，如是，学生可直接缴费报名即可，如不是，可联系成高系统管理员后台删除未支付订单。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item13" name="item">
          <label for="item13">13.朋友的微信帮学生报名，学生如何看网课</label>
          <div class="context">
            <p>可联系系统管理员提供考前辅导课兑换码进行免费兑换开通课程</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item14" name="item">
          <label for="item14">14.考前辅导课用电脑如何看</label>
          <div class="context">
            <p>通过线上直接报名的用户，考前辅导课只能在手机上观看；通过给兑换码开通的课程可在手机上观看，也可在电脑上观看，网址：https://www.cwwdaxue.com，登陆后，点击右上角【我的已购】即可查看课程。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item15" name="item">
          <label for="item15">15.学员自己可修改报名院校/层次/专业信息吗</label>
          <div class="context">
            <p>如果报名时选择的是待定状态，则学员可自己修改且只有一次修改的机会；如报名时已选择了院校/层次/专业，则需要后台管理员在后台修改。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item16" name="item">
          <label for="item16">16.成高小程序奖金提现需知</label>
          <div class="context">
            <p>第一、操作提现时务必填写本人的真实名字；第二、提现的微信必须是已实名认证的微信；第三、单次提现的金额不能大于5000元，如超过则无法提现。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item17" name="item">
          <label for="item17">17.如何添加用户为自己的助理合伙人</label>
          <div class="context">
            <p>前往【陈文卫成高】公众号 -【人人招生】-【合伙人招募】，生成二维码发给用户填写相关资料后，前往【我的团队】-【未审核】进行查看审核通过即可。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item18" name="item">
          <label for="item18">18.学生报名后手机微信未收到用户报名消息</label>
          <div class="context">
            <p>首先可核实学生是不是通过扫自己的码报的名，然后可到【我的业绩】查看是否有显示增加学生报名业绩，如有，则正常。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item19" name="item">
          <label for="item19">19.之前已线上报专科，现升本科的学员线上如何报名</label>
          <div class="context">
            <p>由于目前系统一个微信只支持存在一条报名记录，用户可通过以下三种方式进行报名：第一、走线下报名；第二、用另外一个微信报名。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item20" name="item">
          <label for="item20">20.考前辅导课看不到全部的章节课程</label>
          <div class="context">
            <p>进入对应的考前辅导课课程目录后，点击课程的名字进去即可查看全部的章节视频。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item21" name="item">
          <label for="item21">21.学生报名缴费时出现【当前交易存在被骗风险，为保障...】提示</label>
          <div class="context">
            <p>此提示与成高系统本身无关，是微信支付的风控风险提示，学员通过操作 申请解除限制 即可，或通过转账让管理员后台帮缴费。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item22" name="item">
          <label for="item22">22.学生报名缴费时出现【当前交易异常，暂无法完成支付...】提示</label>
          <div class="context">
            <p>此提示与成高系统本身无关，是微信支付的风控风险提示，学员通过点击 查看解决方法 根据微信官方的操作提示完成即可，或通过转账让管理员后台帮缴费。</p>
          </div>
        </div>

        <div class="problem">
          <input type="radio" id="item23" name="item">
          <label for="item23">23.学生申请成为合伙人时提示：请向您的上级申请助理合伙人</label>
          <div class="context">
            <p>说明该学员已经助理合伙人的粉丝或报名学员，此情况下可再申请成为助理合伙人。如果该学员是你助理合伙人的粉丝，那么他推荐学员报名时提成不受影响，按正常流程操作即可；如果该学员是另外招生助理合伙人的粉丝或已报名学员，那么介绍学员报名时介绍费则要走线下流程给。</p>
          </div>
        </div>

    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'Questions',
  components: {
    Header
  },
  data() {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
  watch: {
  }
};
</script>


<style lang='less' scoped>
  .Questions {
    width: 100%;
    .Questions-content {
      width: 98%;
      margin: 13% auto 0 auto;
      border-radius: 1px;
      .problem {
        width: 100%;
        input {
        	display: none;
        }
        label {
        	display: block;
        	background-color: #FAFAFA;
        	height: auto;
        	margin: 0 auto;
        	border: 1px solid #dddddd;
        	border-radius: 2px;
        	margin-top: 5px;
        	line-height: 17px;
        	cursor: pointer;
        	padding: 10px;
        	text-align: left;
        }
        .context {
        	width: 100%;
        	height: 0px;
        	margin: 0 auto;
        	background-color: #e2edfc;
        	visibility: hidden;
          p {
            text-align: justify;
            padding: 10px;
          }
        }
        input:checked+label+.context {
        	visibility: visible;
        	height: auto;
        }
      }
    }
  }



</style>
